import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import OnchainProviders from "./providers/OnchainProviders";
import ErrorBoundary from "./components/shared/ErrorBoundary";
import App from "./App";
import { isIOSBuild, isSteamDesktop } from "./lib/platform";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <OnchainProviders>
        <App />
      </OnchainProviders>
    </ErrorBoundary>
  </React.StrictMode>
);

// Service Worker
// Only register in production builds; in dev, clean up any stale SW so Vite HMR works.
if ("serviceWorker" in navigator) {
  const shouldRegisterServiceWorker =
    import.meta.env.PROD && !isSteamDesktop() && !isIOSBuild();

  if (shouldRegisterServiceWorker) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    });
  } else {
    // Native iOS and dev should not keep stale web caches around.
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister());
    });
    if (window.caches) {
      caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
    }
  }
}
